import * as Yup from 'yup';

export const generalSettingsValidationSchema = Yup.object({
    additionalChargeId: Yup.string().required().nullable(),
    invoiceDueDays: Yup.number().required().nullable(),
    dueDateAlert: Yup.object({
        amount: Yup.number().required().nullable(),
    }),
}).test('max-invoice-due-days', 'Due date alert cannot be greater than the invoice due days', function (values) {
    const { invoiceDueDays, dueDateAlert } = values ?? {};

    if (dueDateAlert?.amount == null || invoiceDueDays == null || dueDateAlert.amount <= invoiceDueDays) {
        return true;
    }

    return this.createError({ path: `${this.path ? `${this.path}.` : ''}dueDateAlert.amount` });
});
